export var LevelOfDetail;
(function (LevelOfDetail) {
    LevelOfDetail["rt"] = "rt";
})(LevelOfDetail || (LevelOfDetail = {}));
export const getAssetURLs = (products, levelOfDetail) => {
    const satisfiesLevelOfDetail = (asset) => asset.levelOfDetail === levelOfDetail;
    const getAssetUrlFromAsset = (asset) => asset.url;
    return Object.entries(products).reduce((acc, [id, product]) => {
        var _a;
        const asset = (_a = getAssetsOfProduct(product)) === null || _a === void 0 ? void 0 : _a.filter(satisfiesLevelOfDetail)[0];
        return asset ? Object.assign(Object.assign({}, acc), { [id]: getAssetUrlFromAsset(asset) }) : acc;
    }, {});
};
export const getAssetsOfProduct = (product) => { var _a; return (_a = product.content) === null || _a === void 0 ? void 0 : _a.asset; };
export const getAssetsOfProducts = (products, levelOfDetail) => {
    const satisfiesLevelOfDetail = (asset) => asset.levelOfDetail === levelOfDetail;
    return Object.entries(products).reduce((acc, [id, product]) => {
        var _a;
        const assets = (_a = getAssetsOfProduct(product)) === null || _a === void 0 ? void 0 : _a.filter(satisfiesLevelOfDetail);
        return assets ? Object.assign(Object.assign({}, acc), { [id]: assets }) : acc;
    }, {});
};
